import i18n from 'modules/core/lib/i18n'

import Item from 'modules/contracts/components/ContractDetails/LegalAndLabour/Item'

interface Props {
  cotizationGroup?: string
}

const ContributionGroup = ({ cotizationGroup }: Props) => {
  return (
    <Item
      title={i18n.t('contract_versions.legal_and_labour.spain.contribution_group')}
      description={cotizationGroup}
    />
  )
}

export default ContributionGroup
